<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.doctransp_id+''" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Detalhes
							<i class="fa fa-plus"></i>
						</span>
					</a>
				</li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.doctransp_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Adicional
                      <i class="fa fa-plus-square"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t3'+rowData.doctransp_id+''" v-if="rowData.doc_transp_anulacao" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Anulação
                      <i class="fa fa-ban"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t4'+rowData.doctransp_id+''" v-if="rowData.doc_transp_complementado" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Complementado
                      <i class="fa fa-user"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t5'+rowData.doctransp_id+''" v-if="rowData.doc_transp_demais_doc" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Demais Documentos
                      <i class="fa fa-file"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t6'+rowData.doctransp_id+''" v-if="rowData.doc_transp_duplicata" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Duplicata
                      <i class="fa fa-copy"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t7'+rowData.doctransp_id+''" v-if="rowData.doc_transp_imposto" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Imposto
                      <i class="fa fa-envelope"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t8'+rowData.doctransp_id+''" v-if="rowData.doc_transp_duto" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Duto
                      <i class="fa fa-uso"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t9'+rowData.doctransp_id+''" v-if="rowData.doc_transp_autorizados_down_xml" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Autorizados Download XML
                      <i class="fa fa-download"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t11'+rowData.doctransp_id+''" v-if="rowData.doc_transp_onu" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      ONU
                      <i class="fa fa-globe"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t12'+rowData.doctransp_id+''" v-if="rowData.doc_transp_veiculo" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Veículo
                      <i class="fa fa-car"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t13'+rowData.doctransp_id+''" v-if="rowData.doc_transp_inf_carga" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Informações de Carga
                      <i class="fa fa-info-circle"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t14'+rowData.doctransp_id+''" v-if="rowData.doc_transp_aereo" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Aéreo
                      <i class="fa fa-plane"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t15'+rowData.doctransp_id+''" v-if="rowData.doc_transp_aqua" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Aquaviário
                      <i class="fa fa-ship"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t16'+rowData.doctransp_id+''" v-if="rowData.doc_transp_ferro" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Ferroviário
                      <i class="fa fa-train"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t17'+rowData.doctransp_id+''" v-if="rowData.doc_transp_multi" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Multi
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t18'+rowData.doctransp_id+''" v-if="rowData.doc_transp_sub" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Sub
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t19'+rowData.doctransp_id+''" v-if="rowData.doc_transp_uso_livre_fisco" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Uso Livre
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t20'+rowData.doctransp_id+''" v-if="rowData.doc_transp_vlr_prestacao" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Prestação
                      <i class="fa fa-envelope"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t21'+rowData.doctransp_id+''" v-if="rowData.doc_transp_seguro_carga!==null" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Seguro
                      <i class="fa fa-shield"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t22'+rowData.doctransp_id+''" v-if="rowData.doc_transp_rodo!==null" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Rodoviário
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t23'+rowData.doctransp_id+''" v-if="rowData.doc_transp_rodo!==null" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Ordem de Coleta
                      <i class="fa fa-list-ol"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t24'+rowData.doctransp_id+''" v-if="rowData.doc_transp_rodo!==null" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Vale Pedágio
                      <i class="fa fa-file"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t25'+rowData.doctransp_id+''" v-if="rowData.doc_transp_doc_ant>0" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Documentos Anteriores
                      <i class="fa fa-copy"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t26'+rowData.doctransp_id+''" v-if="rowData.doc_transp_doc_carga!==null" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Informações de Documentos
                      <i class="fa fa-info-circle"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.doctransp_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 5%">UF Emitente</th>
                                <th style="width: 20%">Chave</th>
                                <th style="width: 10%">NOP</th>
                                <th style="width: 5%">Ambiente</th>
                                <th style="width: 5%">Tipo CTE</th>
                                <th style="width: 10%">UF - Município de Envio</th>
                                <th style="width: 5%">Tipo Serviço</th>
                                <th style="width: 15%">UF - Município Início Prestação</th>
                                <th style="width: 15%">UF - Município Fim Prestação</th>
                                <th style="width: 5%">Tomador</th>
                                <th style="width: 5%">Status</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ rowData.uf_emitente }}
                                </td>
                                <td>
                                    {{ rowData.chave }}
                                </td>
                                <td>
                                    {{ rowData.nop }}
                                </td>
                                <td>
                                    {{ rowData.ambiente }}
                                </td>
                                <td>
                                    {{ rowData.tp_cte }}
                                </td>
                                <td>
                                    {{ rowData.uf_envio_cte }} - {{ rowData.municipio_envio_cte }}
                                </td>
                                <td>
                                    {{ rowData.tp_servico }}
                                </td>
                                <td>
                                    {{ rowData.uf_inicio_prest }} - {{ rowData.desc_municip_inicio_prest }} - {{ rowData.cd_municip_inicio_prest }}
                                </td>
                                <td>
                                    {{ rowData.uf_fim_prest }} - {{ rowData.desc_municip_fim_prest }} - {{ rowData.cd_municip_fim_prest }}
                                </td>
                                <td>
                                    {{ rowData.tomador }}
                                </td>
                                <td>
                                    {{ rowData.status }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                  <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t2'+rowData.doctransp_id+''">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Código</th>
                                          <th style="width: 5%">Forma de Pagamento</th>
                                          <th style="width: 5%">Modelo de Documento</th>
                                          <th style="width: 5%">Formato de Impressão</th>
                                          <th style="width: 5%">Forma de Emissão</th>
                                          <th style="width: 5%">Digito Verificador</th>
                                          <th style="width: 5%">Identficador de Processo</th>
                                          <th style="width: 10%">Versão de Processo</th>
                                          <th style="width: 20%">Info Adicional Fisco</th>
                                          <th style="width: 20%">Obs Geral</th>
                                          <th style="width: 5%">Código Fluxo Origem</th>
                                          <th style="width: 5%">Código Fluxo Destino</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_adicional.cd_aleatorio }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.forma_pagamento }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.modelo_doc_fiscal }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.formato_impressao }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.forma_emissao }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.digito_verificador }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.iden_processo_emi }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.versao_processo_emi }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.info_adicional_fisco }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.cd_fluxo_origem }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.cd_fluxo_destino }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 20%">Observação Geral</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_adicional.obs_geral }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 5%">Fatura</th>
                                          <th style="width: 25%">Numéro Fatura</th>
                                          <th style="width: 25%">Valor Original Fatura</th>
                                          <th style="width: 20%">Valor Desconto Fatura</th>
                                          <th style="width: 25%">Valor Líquido Fatura</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>

                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.num_fatura }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_adicional.vlr_original_fatura) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_adicional.vlr_desconto_fatura) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_adicional.vlr_liquido_fatura)}}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 15%">Retirada</th>
                                          <th style="width: 15%">Retira Carga</th>
                                          <th style="width: 15%">Detalhes da Retirada</th>
                                          <th style="width: 15%">Hora Contigência</th>
                                          <th style="width: 15%">Justificativa Contigência</th>
                                          <th style="width: 5%">Característica Adicional Transporte</th>
                                          <th style="width: 5%">Característica Adicional Serviço</th>
                                          <th style="width: 5%">Funcionário Emitente CTE</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>

                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.retira_carga }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.detalhes_retira_carga }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.dt_hora_contigencia) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.Justificativa_contigencia }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.caracteristica_adic_transp }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.caracteristica_adic_servico }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.funcionario_emi_cte }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Entrega</th>
                                          <th style="width: 5%">Tipo Data Período entrega</th>
                                          <th style="width: 10%">Data Programada</th>
                                          <th style="width: 10%">Data Início Período</th>
                                          <th style="width: 10%">Data Fim Período</th>
                                          <th style="width: 5%">Tipo Hora programada</th>
                                          <th style="width: 10%">Hora Programada</th>
                                          <th style="width: 10%">Hora Início Programada</th>
                                          <th style="width: 10%">Hora Fim Programada</th>
                                          <th style="width: 5%">Município Origem Cálculo</th>
                                          <th style="width: 5%">Município Destino Cálculo</th>
                                          <th style="width: 10%">Valor total Tributos</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>

                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.tp_dt_periodo_entrega }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.dt_programada) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.dt_inicio_periodo) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.dt_fim_periodo) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.tp_hora_programada }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.hora_programada) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.hora_inicio_programada) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_adicional.hora_fim_programada) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.municipio_origem_calculo }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_adicional.municipio_dest_calculo }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_adicional.vlr_total_tributos) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t3'+rowData.doctransp_id+''" v-if="rowData.doc_transp_anulacao">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 60%">Chave CTE</th>
                                          <th style="width: 40%">Data Declaração</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_anulacao.chave_cte }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_anulacao.dt_declaracao) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t4'+rowData.doctransp_id+''" v-if="rowData.doc_transp_complementado">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 100%">Chave CTE</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_complementado.chave_cte }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t5'+rowData.doctransp_id+''" v-if="rowData.doc_transp_demais_doc">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Tipo</th>
                                          <th style="width: 20%">Descrição</th>
                                          <th style="width: 10%">Número</th>
                                          <th style="width: 10%">Valor</th>
                                          <th style="width: 25%">Data de Emissão</th>
                                          <th style="width: 25%">Data prevista entrega</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_demais_doc.tipo_doc }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_demais_doc.descricao_tp_outros }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_demais_doc.num_doc }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_demais_doc.vlr_documento) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_demais_doc.dt_emi) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_demais_doc.dt_prevista_entrega) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t6'+rowData.doctransp_id+''" v-if="rowData.doc_transp_duplicata">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 40%">Número</th>
                                          <th style="width: 30%">Valor</th>
                                          <th style="width: 30%">Vencimento</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_duplicata">
                                          <td>
                                              {{ item.num_duplicata }}
                                          </td>
                                          <td>
                                              {{ formatNumber(item.vlr_duplicata) }}
                                          </td>
                                          <td>
                                              {{ formatDate(item.dt_vencimento) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t7'+rowData.doctransp_id+''" v-if="rowData.doc_transp_imposto">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">CST</th>
                                          <th style="width: 20%">Valor Base</th>
                                          <th style="width: 10%">Alíquota ICMS</th>
                                          <th style="width: 10%">Valor ICMS</th>
                                          <th style="width: 10%">% Redução BC</th>
                                          <th style="width: 10%">Valor BC ICMS ST Retido</th>
                                          <th style="width: 10%">Valor ICMS ST Retido</th>
                                          <th style="width: 10%">Valor Crédito Presumido</th>
                                          <th style="width: 10%">Indicador simples Nacional</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_imposto.cst }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.vlr_base_calculo) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.aliquota_icms) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.vlr_icms) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.percentual_reducao_bc) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.vlr_bc_icms_st_retido) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.vlr_icms_retido) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_imposto.vlr_credito_presumido) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_imposto.indicador_simples_nacional }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t8'+rowData.doctransp_id+''" v-if="rowData.doc_transp_duto">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 40%">Valor Tarifa</th>
                                          <th style="width: 30%">Data Ínicio</th>
                                          <th style="width: 30%">Data Fim</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_duto.vlr_tarifa) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_duto.dt_inicio_prestacao) }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_duto.dt_fim_prestacao) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t9'+rowData.doctransp_id+''" v-if="rowData.doc_transp_autorizados_down_xml">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 50%">CNPJ</th>
                                          <th style="width: 50%">CPF</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_autorizados_down_xml.cnpj }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_autorizados_down_xml.cpf }}
                                          </td>

                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t11'+rowData.doctransp_id+''" v-if="rowData.doc_transp_onu">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Número</th>
                                          <th style="width: 10%">Quantidade</th>
                                          <th style="width: 20%">Produto</th>
                                          <th style="width: 20%">Classe de Risco</th>
                                          <th style="width: 10%">Grupo de Embalagem</th>
                                          <th style="width: 20%">Quantidade Tipo Volume</th>
                                          <th style="width: 10%">Ponto Fulgor</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_onu.num_onu }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.qtde_total_produto }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.nome_produto_perigoso }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.classe_risco }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.grupo_embalagem }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.qtd_tipo_volume }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_onu.ponto_fulgor }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t12'+rowData.doctransp_id+''" v-if="rowData.doc_transp_veiculo">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Chassi</th>
                                          <th style="width: 10%">Código cor</th>
                                          <th style="width: 20%">Descrição Cor</th>
                                          <th style="width: 20%">Código Marca Modelo</th>
                                          <th style="width: 10%">Valor Unitário</th>
                                          <th style="width: 20%">Valor Frete</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_veiculo.chassi }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_veiculo.cd_cor_veiculo }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_veiculo.descr_cor_veiculo }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_veiculo.cd_marca_modelo }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_veiculo.vlr_unit_veiculo) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_veiculo.vlr_frete_unit) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t13'+rowData.doctransp_id+''" v-if="rowData.doc_transp_inf_carga">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 30%">Produto</th>
                                          <th style="width: 10%">Valor Total da Carga</th>
                                          <th v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null" style="width: 10%">Código Unidade Medida</th>
                                          <th v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null" style="width: 10%">Tipo de Medida</th>
                                          <th v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null" style="width: 10%">Peso</th>
                                          <th style="width: 30%">Outras Características da Carga</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_inf_carga">
                                          <td>
                                              {{ item.produto_predominante }}
                                          </td>
                                          <td>
                                              {{ formatNumber(item.vlr_total_carga) }}
                                          </td>
                                          <td>
                                              {{ item.doc_transp_inf_qtd_carga.cd_unid_medida }}
                                          </td v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null">
                                          <td v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null">
                                              {{ item.doc_transp_inf_qtd_carga.tp_medida }}
                                          </td>
                                          <td v-if="rowData.doc_transp_inf_carga.doc_transp_inf_qtd_carga!==null">
                                              {{ formatNumber(item.doc_transp_inf_qtd_carga.qtd_carga) }}
                                          </td>
                                          <td>
                                              {{ item.outras_carac_carga }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t14'+rowData.doctransp_id+''" v-if="rowData.doc_transp_aereo">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Minuta</th>
                                          <th style="width: 10%">Número OCA</th>
                                          <th style="width: 10%">Data Prevista Entrega</th>
                                          <th style="width: 10%">Emissor</th>
                                          <th style="width: 10%">Tomador</th>
                                          <th style="width: 10%">Dimensão</th>
                                          <th v-if="rowData.doc_transp_aereo.doc_transp_aereo_manuseio!==null" style="width: 10%">Manuseio</th>
                                          <th v-if="rowData.doc_transp_aereo.doc_transp_aereo_carga_especial!==null" style="width: 10%">Carga Especial</th>
                                          <th v-if="rowData.doc_transp_aereo.doc_transp_aereo_tarifa!==null" style="width: 5%">Classe</th>
                                          <th v-if="rowData.doc_transp_aereo.doc_transp_aereo_tarifa!==null" style="width: 5%">Código Tarifa</th>
                                          <th v-if="rowData.doc_transp_aereo.doc_transp_aereo_tarifa!==null" style="width: 10%">Valor</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_aereo.num_minuta }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aereo.num_oca }}
                                          </td>
                                          <td>
                                              {{ formatDate(rowData.doc_transp_aereo.dt_prev_entrega) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aereo.ident_emissor }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aereo.ident_tomador }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aereo.dimensao }}
                                          </td>
                                          <td v-if="rowData.doc_transp_aereo.doc_transp_aereo_manuseio!==null">
                                              {{ rowData.doc_transp_aereo.doc_transp_aereo_manuseio.inf_manuseio }}
                                          </td>
                                          <td v-if="rowData.doc_transp_aereo.doc_transp_aereo_carga_especial!==null">
                                              {{ rowData.doc_transp_aereo.doc_transp_aereo_carga_especial.carga_especial }}
                                          </td>
                                          <td v-if="rowData.doc_transp_aereo.doc_transp_aereo_tarifa!==null">
                                              {{ rowData.doc_transp_aereo.doc_transp_aereo_tarifa.classe }}
                                          </td>
                                          <td v-if="rowData.doc_transp_aereo.doc_transp_aereo_carga_especial!==null">
                                              {{ rowData.doc_transp_aereo.doc_transp_aereo_carga_especial.cd_tarifa }}
                                          </td>
                                          <td v-if="rowData.doc_transp_aereo.doc_transp_aereo_carga_especial!==null">
                                              {{ formatNumber(rowData.doc_transp_aereo.doc_transp_aereo_carga_especial.vlr_tarifa) }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                          </div><!--.tab-pane-->
                          <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t15'+rowData.doctransp_id+''" v-if="rowData.doc_transp_aqua">
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Número Controle</th>
                                          <th style="width: 10%">Navio</th>
                                          <th style="width: 10%">Viagem - Direção</th>
                                          <th style="width: 10%">Porto Embarque</th>
                                          <th style="width: 10%">Porto Transbordo</th>
                                          <th style="width: 10%">Porto Destino</th>
                                          <th style="width: 5%">Tipo Navegação</th>
                                          <th style="width: 5%">IRIN</th>
                                          <th style="width: 10%">Valor Prestação BC AFRMM</th>
                                          <th style="width: 10%">Valor AFRMM</th>
                                          <th style="width: 10%">Número Booking</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                          <td>
                                              {{ rowData.doc_transp_aqua.num_controle }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.ident_navio }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.num_viagem }} - {{ rowData.doc_transp_aqua.direcao }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.porto_embarque }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.porto_transbordo }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.porto_destino }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.tp_navegacao }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.irin }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_aqua.vlr_prest_bc_afrmm) }}
                                          </td>
                                          <td>
                                              {{ formatNumber(rowData.doc_transp_aqua.vlr_afrmm) }}
                                          </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.num_booking }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Container</th>
                                          <th style="width: 10%">Número</th>
                                          <th style="width: 10%">Lacre</th>

                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_aqua.doc_transp_aqua_container">
                                          <td>

                                          </td>
                                          <td>
                                              {{ item.num_container }}
                                          </td>
                                          <td v-if="item.doc_transp_aqua_container_lacre!==null">
                                              {{ item.doc_transp_aqua_container_lacre.num_lacre }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                              <table class="table" id="mais" v-if="rowData.doc_transp_aqua.doc_transp_balsa">
                                  <thead>
                                      <tr>
                                          <th style="width: 10%">Balsa</th>
                                          <th style="width: 90%">Identificação</th>
                                      </tr>
                                   </thead>
                                   <tbody>
                                       <tr class="bg-gray-light" style="display: table-row;">
                                         <td>

                                         </td>
                                          <td>
                                              {{ rowData.doc_transp_aqua.doc_transp_balsa.ident_balsa }}
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>
                        </div><!--.tab-pane-->
                        <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t16'+rowData.doctransp_id+''" v-if="rowData.doc_transp_ferro">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Tipo Tráfego</th>
                                      <th style="width: 20%">Responsável Faturamento</th>
                                      <th style="width: 20%">Emitente CTE</th>
                                      <th style="width: 10%">Fluxo</th>
                                      <th style="width: 20%">Identificação Trem</th>
                                      <th style="width: 20%">Valor Frete</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                      <td>
                                          {{ rowData.doc_transp_ferro.tp_trafego }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_mutuo.resp_faturamento }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_mutuo.ferrovia_emitente_cte }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_mutuo.fluxo_ferroviario }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_mutuo.ident_trem }}
                                      </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_ferro.doc_transp_ferro_mutuo.vlr_frete) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_ferro.doc_transp_ferro_envolvidas">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Partes Envolvidas</th>
                                      <th style="width: 10%">Código Rodovia</th>
                                      <th style="width: 10%">CNPJ</th>
                                      <th style="width: 10%">IE</th>
                                      <th style="width: 20%">Nome</th>
                                      <th style="width: 5%">CEP</th>
                                      <th style="width: 30%">Endereço</th>
                                      <th style="width: 5%">UF</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                     <td>

                                     </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.cd_ferrovia }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.cnpj }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.ie }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.nome }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.cep }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.endereco }} - {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.numero }} - {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.complemento }} - {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.bairro }} - {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.nome_municipio }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_envolvidas.uf }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_ferro.doc_transp_ferro_vagoes">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Vagões</th>
                                      <th style="width: 10%">Número</th>
                                      <th style="width: 20%">Tipo</th>
                                      <th style="width: 20%">Capacidade em Toneladas</th>
                                      <th style="width: 20%">Peso Real em Toneladas</th>
                                      <th style="width: 20%">Peso BC Frete</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                     <td>

                                     </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_vagoes.num_vagao }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_ferro.doc_transp_ferro_vagoes.tp_vagao }}
                                      </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_ferro.doc_transp_ferro_vagoes.cap_toneladas) }}
                                      </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_ferro.doc_transp_ferro_vagoes.peso_real_toneladas) }}
                                      </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_ferro.doc_transp_ferro_vagoes.peso_bc_frete_toneladas) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t17'+rowData.doctransp_id+''" v-if="rowData.doc_transp_multi">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 50%">Número Certificado OTM</th>
                                      <th style="width: 50%">Indicador Negociável</th>

                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                      <td>
                                          {{ rowData.doc_transp_multi.num_certif_otm }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_multi.indicador_negociavel }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t18'+rowData.doctransp_id+''" v-if="rowData.doc_transp_sub">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Chave CTE</th>
                                      <th style="width: 10%">Chave CTE ANU</th>
                                      <th style="width: 10%">CNPJ</th>
                                      <th style="width: 5%">CPF</th>
                                      <th style="width: 5%">Modelo</th>
                                      <th style="width: 5%">Série</th>
                                      <th style="width: 5%">Sub série</th>
                                      <th style="width: 5%">Número Documento</th>
                                      <th style="width: 10%">Valor</th>
                                      <th style="width: 10%">Data de Emissão</th>
                                      <th style="width: 10%">Chave NFE SUB</th>
                                      <th style="width: 10%">Chave CTE SUB</th>

                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                      <td>
                                          {{ rowData.doc_transp_sub.chave_cte }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_n_contribuinte.chave_cte_anu }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.cnpj }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.cpf }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.modelo }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.serie }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.sub_serie }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.num_doc }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.vlr }}
                                      </td>
                                      <td>
                                          {{ formatDate(rowData.doc_transp_sub.doc_transp_sub_contribuinte.dt_emi) }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.chave_nfe_sub }}
                                      </td>
                                      <td>
                                          {{ rowData.doc_transp_sub.doc_transp_sub_contribuinte.chave_cte_sub }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t19'+rowData.doctransp_id+''">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th  v-if="rowData.doc_transp_uso_livre_fisco!==null" style="width: 10%">Fisco</th>
                                      <th  v-if="rowData.doc_transp_uso_livre_fisco.identificacao_campo!==null" style="width: 50%">Identificação</th>
                                      <th  v-if="rowData.doc_transp_uso_livre_fisco.conteudo_campo!==null" style="width: 40%">Conteúdo</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_uso_livre_fisco">
                                      <td >

                                      </td>
                                      <td v-if="item.identificacao_campo!==null" >
                                          {{ item.identificacao_campo }}
                                      </td>
                                      <td v-if="item.conteudo_campo!==null" >
                                          {{ item.conteudo_campo }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_uso_livre_contrib">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Contribuinte</th>
                                      <th style="width: 50%">Identificação</th>
                                      <th style="width: 40%">Conteúdo</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_uso_livre_contrib">
                                      <td>

                                      </td>
                                      <td>
                                          {{ item.identificacao_campo }}
                                      </td>
                                      <td>
                                          {{ item.conteudo_campo }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t20'+rowData.doctransp_id+''" v-if="rowData.doc_transp_vlr_prestacao">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Prestação</th>
                                      <th style="width: 40%">Valor Total</th>
                                      <th style="width: 40%">Valor à Receber</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;">
                                     <td>

                                     </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_vlr_prestacao.vlr_total_prestacao) }}
                                      </td>
                                      <td>
                                          {{ formatNumber(rowData.doc_transp_vlr_prestacao.vlr_receber) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_vlr_prestacao.doc_transp_vlr_comp_frete">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Componente</th>
                                      <th style="width: 50%">Nome</th>
                                      <th style="width: 40%">Valor</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_vlr_prestacao.doc_transp_vlr_comp_frete">
                                      <td>

                                      </td>
                                      <td>
                                          {{ item.nome }}
                                      </td>
                                      <td>
                                          {{ formatNumber(item.vlr) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t21'+rowData.doctransp_id+''" v-if="rowData.doc_transp_seguro_carga">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 20%">Responsável</th>
                                      <th style="width: 40%">Nome Seguradora</th>
                                      <th style="width: 20%">Número Apólice</th>
                                      <th style="width: 10%">Número Averbação</th>
                                      <th style="width: 10%">Valor da Carga</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_seguro_carga">
                                     <td>
                                          {{ item.resp_seguro }}
                                     </td>
                                     <td>
                                          {{ item.nome_seguradora }}
                                     </td>
                                     <td>
                                          {{ item.num_apolice }}
                                     </td>
                                      <td>
                                          {{ item.num_averbacao }}
                                      </td>
                                      <td>
                                          {{ formatNumber(item.vlr_carga) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t22'+rowData.doctransp_id+''" v-if="rowData.doc_transp_rodo">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">RNTRC</th>
                                      <th style="width: 25%">Data Prevista para Entrega</th>
                                      <th style="width: 10%">Indicador Lotação</th>
                                      <th style="width: 10%">CIOT</th>
                                      <th style="width: 30%">Nome Motorista</th>
                                      <th style="width: 15%">CPF Motorista</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_rodo.doc_transp_motorista">
                                     <td>
                                          {{ rowData.doc_transp_rodo.rntrc }}
                                     </td>
                                     <td>
                                          {{ formatDate(rowData.doc_transp_rodo.dt_prevista_entrega) }}
                                     </td>
                                     <td>
                                          {{ rowData.doc_transp_rodo.indicador_lotacao }}
                                     </td>
                                      <td>
                                          {{ rowData.doc_transp_rodo.ciot }}
                                      </td>
                                      <td>
                                          {{ item.nome }}
                                      </td>
                                      <td>
                                          {{ item.cpf }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_rodo.doc_transp_rodo_veiculo">
                              <thead>
                                  <tr>
                                      <th style="width: 5%">Código</th>
                                      <th style="width: 10%">RENAVAM</th>
                                      <th style="width: 10%">Placa</th>
                                      <th style="width: 10%">Tara</th>
                                      <th style="width: 10%">Capacidade de KG</th>
                                      <th style="width: 10%">Capacidade de M3</th>
                                      <th style="width: 10%">Tipo de Propriedade</th>
                                      <th style="width: 10%">Tipo de veículo</th>
                                      <th style="width: 5%">Tipo Rodado</th>
                                      <th style="width: 5%">Tipo de Carroceria</th>
                                      <th style="width: 5%">UF</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_rodo.doc_transp_rodo_veiculo">
                                     <td>
                                          {{ item.cd }}
                                     </td>
                                     <td>
                                          {{ item.renavam }}
                                     </td>
                                     <td>
                                          {{ item.placa }}
                                     </td>
                                      <td>
                                          {{ item.tara }}
                                      </td>
                                      <td>
                                          {{ item.cap_kg }}
                                      </td>
                                      <td>
                                          {{ item.cap_m3 }}
                                      </td>
                                      <td>
                                          {{ item.tp_propriedade }}
                                      </td>
                                      <td>
                                          {{ item.tp_veiculo }}
                                      </td>
                                      <td>
                                          {{ item.tp_rodade }}
                                      </td>
                                      <td>
                                          {{ item.tp_carroceria }}
                                      </td>
                                      <td>
                                          {{ item.uf }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_rodo.doc_transp_rodo_lacre">
                              <thead>
                                  <tr>
                                      <th style="width: 100%">Lacre</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_rodo.doc_transp_rodo_lacre">
                                     <td>
                                          {{ item.lacre }}
                                     </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t23'+rowData.doctransp_id+''" v-if="rowData.doc_transp_rodo">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 5%">Série</th>
                                      <th style="width: 10%">Número</th>
                                      <th style="width: 20%">Data Emissão</th>
                                      <th style="width: 5%">Código Transportadora</th>
                                      <th style="width: 20%">CNPJ</th>
                                      <th style="width: 20%">IE</th>
                                      <th style="width: 10%">Fone</th>
                                      <th style="width: 10%">UF</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_rodo.doc_transp_ordem_coleta">
                                     <td>
                                          {{ item.serie_occ }}
                                     </td>
                                     <td>
                                          {{ item.numero_occ }}
                                     </td>
                                     <td>
                                          {{ formatDate(item.dt_emi_occ) }}
                                     </td>
                                      <td>
                                          {{ item.cd_interno_transp }}
                                      </td>
                                      <td>
                                          {{ item.cnpj }}
                                      </td>
                                      <td>
                                          {{ item.ie }}
                                      </td>
                                      <td>
                                          {{ item.fone }}
                                      </td>
                                      <td>
                                          {{ item.uf }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t24'+rowData.doctransp_id+''"  v-if="rowData.doc_transp_rodo">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 5%">CNPJ</th>
                                      <th style="width: 10%">Número Comprovante</th>
                                      <th style="width: 20%">CNPJ PAG</th>
                                      <th style="width: 5%">Valor</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_rodo.doc_transp_vale_pedagio">
                                     <td>
                                          {{ item.cnpj }}
                                     </td>
                                     <td>
                                          {{ item.num_comprovante }}
                                     </td>
                                     <td>
                                          {{ item.cnpj_pag }}
                                     </td>
                                      <td>
                                          {{ formatNumber(item.vlr) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t25'+rowData.doctransp_id+''" v-if="rowData.doc_transp_doc_ant">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 20%">Nome</th>
                                      <th style="width: 20%">CNPJ</th>
                                      <th style="width: 20%">CPF</th>
                                      <th style="width: 20%">IE</th>
                                      <th style="width: 20%">UF</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_ant">
                                     <td>
                                         {{ item.nome }}
                                     </td>
                                     <td>
                                          {{ item.cnpj }}
                                     </td>
                                     <td>
                                          {{ item.cpf }}
                                     </td>
                                     <td>
                                          {{ item.ie }}
                                     </td>
                                      <td>
                                          {{ item.uf }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div><!--.tab-pane-->
                      <div role="tabpanel" class="tab-pane fade"  v-bind:id="'t26'+rowData.doctransp_id+''" v-if="rowData.doc_transp_doc_carga">
                          <table class="table" id="mais">
                              <thead>
                                  <tr>
                                      <th style="width: 20%">Chave</th>
                                      <th style="width: 5%">Modelo</th>
                                      <th style="width: 5%">Série</th>
                                      <th style="width: 5%">Número</th>
                                      <th style="width: 10%">Data Emissão</th>
                                      <th style="width: 5%">Valor BC NF</th>
                                      <th style="width: 5%">Valor Total ICMS NF</th>
                                      <th style="width: 5%">Valor BC ICMS ST NF</th>
                                      <th style="width: 5%">Valor total Produtos NF</th>
                                      <th style="width: 5%">Valor Total NF</th>
                                      <th style="width: 5%">CFOP NF</th>
                                      <th style="width: 5%">Número Romaneio NF</th>
                                      <th style="width: 5%">Peso Total NF</th>
                                      <th style="width: 5%">PIN NF</th>
                                      <th style="width: 10%">Data prevista entrega</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_carga">
                                     <td>
                                         {{ item.chave }}
                                     </td>
                                     <td>
                                          {{ item.modelo_nf }}
                                     </td>
                                     <td>
                                          {{ item.serie }}
                                     </td>
                                     <td>
                                          {{ item.num_nf }}
                                     </td>
                                      <td>
                                          {{ formatDate(item.dt_emi) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_doc_carga>0">
                              <thead>
                                  <tr>
                                      <th  v-if="rowData.doc_transp_doc_carga.vlr_bc_nf!==null" style="width: 5%">Valor BC NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.vlr_total_icms_nf!==null" style="width: 5%">Valor Total ICMS NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.vlr_bc_icms_st_nf!==null" style="width: 5%">Valor BC ICMS ST NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.vlr_total_produtos_nf!==null" style="width: 5%">Valor total Produtos NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.vlr_total_nf!==null" style="width: 5%">Valor Total NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.cfop_nf!==null" style="width: 5%">CFOP NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.num_romaneio_nf!==null" style="width: 5%">Número Romaneio NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.peso_total_nf!==null" style="width: 5%">Peso Total NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.pin_nf!==null" style="width: 5%">PIN NF</th>
                                      <th  v-if="rowData.doc_transp_doc_carga.dt_prevista_entrega_nf!==null" style="width: 10%">Data prevista entrega</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_carga">
                                      <td v-if="item.vlr_bc_nf!==null" >
                                          {{ formatNumber(item.vlr_bc_nf) }}
                                      </td>
                                      <td v-if="item.vlr_total_icms_nf!==null" >
                                          {{ formatNumber(item.vlr_total_icms_nf) }}
                                      </td>
                                      <td v-if="item.vlr_bc_icms_st_nf!==null" >
                                          {{ formatNumber(item.vlr_bc_icms_st_nf) }}
                                      </td>
                                      <td v-if="item.vlr_total_produtos_nf!==null" >
                                          {{ formatNumber(item.vlr_total_produtos_nf) }}
                                      </td>
                                      <td v-if="item.vlr_total_nf!==null" >
                                          {{ formatNumber(item.vlr_total_nf) }}
                                      </td>
                                      <td v-if="item.cfop_nf!==null" >
                                          {{ item.cfop_nf }}
                                      </td>
                                      <td v-if="item.num_romaneio_nf!==null" >
                                          {{ item.num_romaneio_nf }}
                                      </td>
                                      <td v-if="item.peso_total_nf!==null" >
                                          {{ formatNumber(item.peso_total_nf) }}
                                      </td>
                                      <td v-if="item.pin_nf!==null" >
                                          {{ item.pin_nf }}
                                      </td>
                                      <td v-if="item.dt_prevista_entrega_nf!==null" >
                                          {{ formatDate(item.dt_prevista_entrega_nf) }}
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte[0]">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Carga</th>
                                      <th style="width: 40%">Tipo Unidade</th>
                                      <th style="width: 40%">Código Unidade</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte[0].doc_transp_unid_carga">
                                     <td>

                                     </td>
                                     <td>
                                         {{ item.tp_unidade }}
                                     </td>
                                     <td>
                                          {{ item.código_unidade }}
                                     </td>
                                  </tr>
                              </tbody>
                          </table>
                          <table class="table" id="mais" v-if="rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte[0]">
                              <thead>
                                  <tr>
                                      <th style="width: 10%">Lacre</th>
                                      <th style="width: 90%">Número Lacre</th>
                                  </tr>
                               </thead>
                               <tbody>
                                   <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte[0].doc_transp_unid_carga[0].doc_transp_unid_carga_lacre">
                                     <td>

                                     </td>
                                     <td>
                                         {{ item.num_lacre }}
                                     </td>
                                  </tr>
                              </tbody>
                          </table>
                      <table class="table" id="mais" v-if="rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte[0]">
                          <thead>
                              <tr>
                                  <th style="width: 10%">Transporte</th>
                                  <th style="width: 40%">Tipo Unidade</th>
                                  <th style="width: 40%">Código Unidade</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.doc_transp_doc_carga[0].doc_transp_unid_transporte">
                                 <td>

                                 </td>
                                 <td>
                                     {{ item.tp_unidade }}
                                 </td>
                                 <td>
                                      {{ item.código_unidade }}
                                 </td>
                              </tr>
                          </tbody>
                      </table>
                  </div><!--.tab-pane-->
	 	</div><!--.tab-content-->
	</div>
</div>
</template>

  <script>
  import accounting from 'accounting'
  import moment from 'moment'
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      formatNumber (value) {
          return accounting.formatNumber(value, 2, ',', '.')
      },
      formatDate (value, fmt = 'D/MM/YYYY HH:mm') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      }
    },
  }
  </script>
